import getStore from 'services/getStore';

const store = getStore();

const getFontSize = (base, h) => {
  // const { fontSizes } = store.getState().theme || {};
  // const fontSizeScaled = fontSizes['Large screen'] / 16;

  // console.log({ h });

  // * fontSizeScaled
  return `
    font-size: ${base + (h > 1 ? h / 10 : 0)}rem;
  `;
};

const headingStyles = ({ h1, h2, h3, h4, h5, h6 }) => `
  h1 {
    ${getFontSize(2, h1)}
  }

  h2 {
    ${getFontSize(1.5, h2)}
  }

  h3 {
    ${getFontSize(1.3, h3)}
  }

  h4 {
    ${getFontSize(1, h4)}
  }

  h5 {
    ${getFontSize(0.8, h5)}
  }

  h6 {
    ${getFontSize(0.6, h6)}
  }

  @media(min-width: 480px) {
    h1 {
        ${getFontSize(2.5, h1)}
    }

    h2 {
        ${getFontSize(2, h2)}
    }

    h3 {
        ${getFontSize(1.8, h3)}
    }

    h4 {
        ${getFontSize(1.5, h4)}
    }

    h5 {
      ${getFontSize(1, h5)}
    }
  
    h6 {
      ${getFontSize(0.8, h6)}
    }
}

  @media(min-width: 767px) {
    h1 {
        ${getFontSize(3.5, h1)}
    }

    h2 {
        ${getFontSize(2.5, h2)}
    }

    h3 {
      ${getFontSize(2, h3)}
    }

    h4 {
      ${getFontSize(1.7, h4)}
    }
  
    h5 {
      ${getFontSize(1.2, h5)}
    }
  
    h6 {
      ${getFontSize(1, h6)}
    }
}
`;

export default headingStyles;
